import { render, staticRenderFns } from "./Rectangle.vue?vue&type=template&id=51841357&scoped=true&"
import script from "./Rectangle.vue?vue&type=script&lang=js&"
export * from "./Rectangle.vue?vue&type=script&lang=js&"
import style0 from "./Rectangle.vue?vue&type=style&index=0&id=51841357&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51841357",
  null
  
)

export default component.exports